import { render, staticRenderFns } from "./DHRSampleMenu.vue?vue&type=template&id=5863793c&scoped=true&"
import script from "./DHRSampleMenu.vue?vue&type=script&lang=js&"
export * from "./DHRSampleMenu.vue?vue&type=script&lang=js&"
import style0 from "./DHRSampleMenu.vue?vue&type=style&index=0&id=5863793c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863793c",
  null
  
)

export default component.exports